
const state = {
  tour: {
    product: false,
    finder: false,
    workflow: false,
    eln: false
  },
  tourFlag: false,
  isTabletView: false
}
const getters = {
  getTour: (state) => (prop) => {
    return state.tour[prop]
  },
  getTourFlag: (state) => {
    return state.tourFlag;
  },
  getisTabletView: (state) => {
    return state.isTabletView;
  }
}
const actions = {
  setTour: ({ commit, state }, payload) => {
    commit('setTour', {...state.tour, ...payload});
  },
  setTourFlag: ({ commit, state }, payload) => {
    commit('setTourFlag', payload);
  },
  setIsTabletView: ({ commit, state }, payload) => {
    commit('setTourFlag', payload);
  }
}
const mutations = {
  setTour: (state, payload) => {
    state.tour = payload
  },
  setTourFlag: (state, payload) => {
    state.tourFlag = payload;
  },
  setIsTabletView: (state, payload) => {
    state.isTabletView = payload;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
